// Date formatting shared by the admin users table and a user's detail page, so
// "last login" reads the same in the row an admin clicked and on the page they
// land on.

export const formatDate = (value) => {
  if (!value) return null
  return new Date(value).toLocaleDateString()
}

export const formatDateTime = (value) => {
  if (!value) return null
  return new Date(value).toLocaleString([], {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatTimeAgo = (value) => {
  if (!value) return 'never'
  const date = new Date(value)
  const diffMs = new Date() - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMins / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins} minutes ago`
  if (diffHours < 24) return `${diffHours} hours ago`
  if (diffDays < 30) return `${diffDays} days ago`
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`
  return `${Math.floor(diffDays / 365)} years ago`
}
